import React, { useEffect, useState } from "react";
import { FaEdit, FaTrash, FaPlus, FaDownload } from "react-icons/fa";
import { QRCodeCanvas } from "qrcode.react";
import Swal from "sweetalert2";

import "./Admin.css";

function Dashboard() {
  const [list, setList] = useState([]);
  const [editId, setEditId] = useState(null);
  const token = localStorage.getItem("token");

  const [form, setForm] = useState({
    name: "",
    designation: "",
    mobile: "",
    email: "",
    state: "",
    city: "",
    user_id: "",
  });

  useEffect(() => {
    if (!token) {
      window.location.href = "/login";
    }
  }, [token]);

  const [showModal, setShowModal] = useState(false);

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 5;

  const handleSubmit = async () => {
    try {
      const url = editId ? "/api/update-id" : "/api/add-id";

      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          id: editId,
          name: form.name,
          designation: form.designation,
          mobile: form.mobile,
          email: form.email,
          state: form.state,
          city: form.city,
          user_id: form.user_id,
        }),
      });

      setShowModal(false);
      fetchData();
    } catch (err) {
      console.error(err);
    }
  };

  const editRecord = (item) => {
    setForm({
      name: item.user_name || "",
      designation: item.designation || "",
      mobile: item.mobile || "",
      email: item.email || "",
      state: item.state || "",
      city: item.city || "",
      user_id: item.id_number || "",
    });

    console.log("EDIT ITEM:", item);

    setEditId(item.id);
    setShowModal(true);
  };

  const deleteRecord = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Delete",
    });

    if (!result.isConfirmed) return;

    try {
      const res = await fetch("/api/delete-id", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ id }),
      });

      const data = await res.json();

      if (data.status === "success") {
        fetchData();
      } else {
        alert("Delete failed");
      }
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  const fetchData = async () => {
    try {
      const res = await fetch("/api/all-ids", {
        headers: {
          Authorization: token,
        },
      });

      const data = await res.json();
      console.log("DATA:", data);

      if (Array.isArray(data)) {
        setList(data);
      } else {
        console.error("API error:", data);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  useEffect(() => {
    if (token) {
      fetchData();
    }
  }, [token]);

  // QR DOWNLOAD
  const downloadQR = (item) => {
    const qrCanvas = document.getElementById(`qr-${item.id}`);
  
    if (!qrCanvas) return;
  
    const finalCanvas = document.createElement("canvas");
    const ctx = finalCanvas.getContext("2d");
  
    finalCanvas.width = 250;
    finalCanvas.height = 320;
  
    // Background
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);
  
    // Draw QR
    ctx.drawImage(qrCanvas, 35, 20, 180, 180);
  
    // Text
    ctx.fillStyle = "#000";
    ctx.font = "bold 18px Arial";
    ctx.textAlign = "center";
  
    ctx.fillText(
      `Name: ${item.user_name}`,
      finalCanvas.width / 2,
      240
    );
  
    ctx.fillText(
      `UserID: ${item.id_number}`,
      finalCanvas.width / 2,
      275
    );
  
    // Download
    const pngUrl = finalCanvas.toDataURL("image/png");
  
    const downloadLink = document.createElement("a");
  
    downloadLink.href = pngUrl;
    downloadLink.download = `${item.user_name}-qr.png`;
  
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  // pagination
  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;

  const currentRecords = list.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(list.length / recordsPerPage);

  return (
    <div className="admin-wrapper">
      {/* HEADER */}
      <div className="top-bar">
        <h2>Admin Dashboard</h2>
       
        <button
          className="add-btn"
          onClick={() => {
            setForm({
              name: "",
              designation: "",
              mobile: "",
              email: "",
              state: "",
              city: "",
              user_id: "",
            });

            setEditId(null);
            setShowModal(true);
          }}
        >
          <FaPlus /> Add
        </button>
      </div>

      {/* TABLE */}
      <div className="table-container">
        <table className="styled-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Designation</th>
              <th>Mobile</th>
              <th>Email</th>
              <th>State</th>
              <th>City</th>
              <th>User ID</th>
              <th>QR Code</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {currentRecords.map((item) => (
              <tr key={item.id}>
                <td>{item.user_name}</td>
                <td>{item.designation || "-"}</td>
                <td>{item.mobile || "-"}</td>
                <td>{item.email || "-"}</td>
                <td>{item.state || "-"}</td>
                <td>{item.city || "-"}</td>
                <td>{item.id_number}</td>

                {/* QR CODE COLUMN */}
                <td>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <QRCodeCanvas
                      id={`qr-${item.id}`}
                      value={`https://asbntv.com/verify-id/${item.id_number}`}
                      size={80}
                    />

                    <button
                    onClick={() => downloadQR(item)}
                    style={{
                      border: "none",
                      background: "#007bff",
                      color: "#fff",
                      padding: "5px 8px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Download
                  </button>
                  </div>
                </td>

                <td>
                  <button
                    className="edit-btn"
                    onClick={() => editRecord(item)}
                  >
                    <FaEdit />
                  </button>

                  <button
                    onClick={() => deleteRecord(item.id)}
                    className="delete-btn"
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {showModal && (
          <div
            className="modal-overlay"
            onClick={() => setShowModal(false)}
          >
            <div
              className="modal"
              onClick={(e) => e.stopPropagation()}
            >
              <h3>{editId ? "Edit Record" : "Add Record"}</h3>

              <div className="form-grid">
                <div className="form-group">
                  <label>Name</label>

                  <input
                    value={form.name}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        name: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="form-group">
                  <label>Designation</label>

                  <select
                    value={form.designation}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        designation: e.target.value,
                      })
                    }
                  >
                    <option value="">
                      Select Designation
                    </option>

                    <option value="Reporter">
                      Reporter
                    </option>

                    <option value="Editor">
                      Editor
                    </option>

                    <option value="Anchor">
                      Anchor
                    </option>

                    <option value="Admin">
                      Admin
                    </option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Mobile</label>

                  <input
                    value={form.mobile}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        mobile: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="form-group">
                  <label>Email</label>

                  <input
                    value={form.email}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        email: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="form-group">
                  <label>State</label>

                  <select
                    value={form.state}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        state: e.target.value,
                      })
                    }
                  >
                    <option value="">
                      Select State
                    </option>

                    <option>Uttar Pradesh</option>
                    <option>Delhi</option>
                    <option>Maharashtra</option>
                    <option>Gujarat</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>City</label>

                  <input
                    value={form.city}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        city: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="form-group">
                  <label>User ID</label>

                  <input
                    value={form.user_id}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        user_id: e.target.value,
                      })
                    }
                  />
                </div>
              </div>

              <div className="modal-buttons">
                <button
                  className="btn cancel"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn primary"
                  onClick={handleSubmit}
                >
                  {editId ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* PAGINATION */}
      <div className="pagination">
        <button
          disabled={currentPage === 1}
          onClick={() =>
            setCurrentPage(currentPage - 1)
          }
        >
          Prev
        </button>

        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            className={
              currentPage === i + 1 ? "active" : ""
            }
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}

        <button
          disabled={currentPage === totalPages}
          onClick={() =>
            setCurrentPage(currentPage + 1)
          }
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default Dashboard;